const lastActiveTimeName = "admin-lastActiveTime";

export const resetInactivityTimer = () => {
    localStorage.setItem(lastActiveTimeName, new Date().toISOString());
};
